<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 512 512"
>
  <path
    d="M449.861 246.663c-4.418 36.17-20.971 68.592-45.458 93.078l-57.422 57.422-46.671-46.671 149.551-103.829z"
    fill="#fec45e"
  />
  <path
    d="m242.282 408.52 149.714-103.042c-4.589 35.579-20.932 67.48-45.014 91.686l-.304.304-57.724 57.724-46.672-46.672zM449.861 246.663c-4.418 36.171-20.971 68.592-45.458 93.078l57.724-57.724c28.827-28.828 46.648-68.63 46.648-112.595 0-43.514-17.439-82.951-45.723-111.684l-13.191 188.925z"
    fill="#ffad61"
  />
  <path
    d="M349.525 10.171c-43.965 0-83.767 17.821-112.595 46.648l-57.422 57.422L449.86 246.663c22.854-26.883 38.449-59.623 42.377-93.779 4.465-38.846-7.001-72.278-29.186-95.147-.506-.521-1.011-1.026-1.525-1.54-28.762-28.454-68.332-46.026-112.001-46.026z"
    fill="#fec45e"
  />
  <path
    d="M291.801 67.895c-43.816-.008-83.503 17.697-112.291 46.345-.109.094-.21.195-.311.296l-57.686 57.701 270.484 133.239 46.795-46.795c3.85-3.85 7.553-7.864 11.069-12.018a161.619 161.619 0 0 0 1.183-19.524c.007-87.952-71.292-159.25-159.243-159.244z"
    fill="#fcdb5a"
  />
  <path
    d="M234.075 125.621c-43.965 0-83.752 17.806-112.563 46.617l-57.764 57.749 270.523 133.216 57.724-57.724c.879-6.744 1.33-13.62 1.33-20.605.001-87.963-71.289-159.253-159.25-159.253z"
    fill="#fec45e"
  />
  <path
    d="M292.322 159.946a8.214 8.214 0 0 1-3.154-.63 8.249 8.249 0 0 1-4.465-10.779l8.717-21.045c1.743-4.209 6.573-6.211 10.779-4.465a8.249 8.249 0 0 1 4.465 10.779l-8.717 21.045a8.25 8.25 0 0 1-7.625 5.095zM236.929 147.79a8.249 8.249 0 0 1-8.25-8.25v-22.778c0-4.558 3.693-8.25 8.25-8.25s8.25 3.693 8.25 8.25v22.778a8.25 8.25 0 0 1-8.25 8.25z"
    fill="#fec45e"
  />
  <path
    d="M427.162 182.411a8.254 8.254 0 0 1-7.626-5.095 8.247 8.247 0 0 1 4.465-10.779l21.044-8.718a8.248 8.248 0 0 1 10.779 4.465 8.247 8.247 0 0 1-4.465 10.779l-21.044 8.718a8.239 8.239 0 0 1-3.153.63zM396.581 134.644a8.25 8.25 0 0 1-5.835-14.084l16.107-16.107a8.25 8.25 0 0 1 11.668 11.668l-16.107 16.107a8.221 8.221 0 0 1-5.833 2.416z"
    fill="#fcdb5a"
  />
  <path
    d="M503.744 244.628a8.251 8.251 0 0 1-3.154-.63l-21.044-8.718c-4.21-1.744-6.21-6.571-4.465-10.779a8.251 8.251 0 0 1 10.779-4.465l21.044 8.718c4.21 1.744 6.21 6.571 4.465 10.779a8.253 8.253 0 0 1-7.625 5.095z"
    fill="#ffad61"
  />
  <path
    d="M407.775 44.493a8.214 8.214 0 0 1-3.154-.63 8.249 8.249 0 0 1-4.465-10.779l8.717-21.044c1.745-4.209 6.574-6.211 10.779-4.465a8.249 8.249 0 0 1 4.465 10.779L415.4 39.398a8.253 8.253 0 0 1-7.625 5.095zM296.555 42.31a8.254 8.254 0 0 1-7.626-5.095l-8.717-21.044a8.247 8.247 0 0 1 4.465-10.779 8.247 8.247 0 0 1 10.779 4.465l8.717 21.044a8.247 8.247 0 0 1-4.465 10.779 8.209 8.209 0 0 1-3.153.63z"
    fill="#fec45e"
  />
  <circle cx="176.35" cy="342.591" r="159.244" fill="#fcdb5a" />
  <circle
    cx="176.35"
    cy="342.591"
    r="106.166"
    fill="#ffe6b8"
  />
  <path
    d="M31.028 347.99H8.25A8.249 8.249 0 0 1 0 339.74a8.249 8.249 0 0 1 8.25-8.25h22.778a8.249 8.249 0 0 1 8.25 8.25 8.248 8.248 0 0 1-8.25 8.25zM19.959 412.539a8.254 8.254 0 0 1-7.626-5.095 8.247 8.247 0 0 1 4.465-10.779l21.044-8.717a8.248 8.248 0 0 1 10.779 4.465 8.247 8.247 0 0 1-4.465 10.779l-21.044 8.717a8.212 8.212 0 0 1-3.153.63zM238.052 507.24a8.254 8.254 0 0 1-7.626-5.095L221.71 481.1a8.247 8.247 0 0 1 4.465-10.779 8.246 8.246 0 0 1 10.779 4.465l8.717 21.044a8.247 8.247 0 0 1-4.465 10.779 8.219 8.219 0 0 1-3.154.631zM281.128 250.096a8.25 8.25 0 0 1-5.835-14.084l16.107-16.107a8.25 8.25 0 0 1 11.668 11.668l-16.107 16.107a8.223 8.223 0 0 1-5.833 2.416zM75.608 246.066a8.229 8.229 0 0 1-5.835-2.416l-16.107-16.107a8.25 8.25 0 0 1 11.668-11.668l16.107 16.107a8.25 8.25 0 0 1-5.833 14.084z"
    fill="#fcdb5a"
  />
  <circle cx="176.35" cy="342.591" r="53.078" fill="#fcdb5a" />
</svg>
